
import React, { useState } from 'react';
import './AddProductModal.css';
import { useApp } from '../../context/AppContext';

interface AddProductModalProps {
  onClose: () => void;
}

const AddProductModal: React.FC<AddProductModalProps> = ({ onClose }) => {
  const { addProduct } = useApp();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [category, setCategory] = useState('Hoodies');
  const [stock, setStock] = useState('10');
  const [featured, setFeatured] = useState(false);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);

  const categories = ['Hoodies', 'Tops', 'Bottoms', 'Accessories'];

  const generateProductImage = (color: string) => {
    return `data:image/svg+xml,${encodeURIComponent(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 500">
        <defs>
          <linearGradient id="prodGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style="stop-color:#f8f9fa;stop-opacity:1" />
            <stop offset="100%" style="stop-color:#e9ecef;stop-opacity:1" />
          </linearGradient>
        </defs>
        <rect width="400" height="500" fill="url(#prodGrad)"/>
        <rect x="50" y="50" width="300" height="400" rx="10" fill="${color}" opacity="0.9"/>
        <text x="200" y="270" font-size="80" text-anchor="middle" fill="white" font-family="Arial">★</text>
        <text x="200" y="340" font-size="24" text-anchor="middle" fill="rgba(255,255,255,0.8)" font-family="Arial">NEW</text>
      </svg>
    `)}`;
  };

  const handleSubmit = () => {
    if (!name.trim() || !price) return;

    setSaving(true);
    setTimeout(() => {
      const colors = ['#6366f1', '#8b5cf6', '#ec4899', '#f59e0b', '#10b981'];
      const color = colors[Math.floor(Math.random() * colors.length)];

      addProduct({
        name,
        description,
        price: parseFloat(price),
        images: [generateProductImage(color)],
        category,
        sizes: [
          { size: 'S', stock: Math.floor(parseInt(stock) / 4) },
          { size: 'M', stock: Math.floor(parseInt(stock) / 4) },
          { size: 'L', stock: Math.floor(parseInt(stock) / 4) },
          { size: 'XL', stock: Math.floor(parseInt(stock) / 4) }
        ],
        stock: parseInt(stock),
        featured
      });
      setSuccess(true);
      setTimeout(onClose, 1500);
    }, 1000);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="add-product-modal animate-slide-up" onClick={e => e.stopPropagation()}>
        <div className="modal-handle" />

        {success ? (
          <div className="product-success">
            <div className="success-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
              </svg>
            </div>
            <h3>Product Added!</h3>
            <p>Your new product is now available in the shop</p>
          </div>
        ) : (
          <>
            <div className="modal-header">
              <h2>Add New Product</h2>
              <button className="close-btn" onClick={onClose}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 6L6 18M6 6l12 12"/>
                </svg>
              </button>
            </div>

            <div className="product-form">
              <div className="form-group">
                <label>Product Name</label>
                <input
                  type="text"
                  placeholder="e.g., Limited Edition Hoodie"
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea
                  placeholder="Describe your product..."
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  rows={3}
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Price ($)</label>
                  <input
                    type="number"
                    placeholder="49.99"
                    value={price}
                    onChange={e => setPrice(e.target.value)}
                    step="0.01"
                    min="0"
                  />
                </div>

                <div className="form-group">
                  <label>Stock</label>
                  <input
                    type="number"
                    placeholder="10"
                    value={stock}
                    onChange={e => setStock(e.target.value)}
                    min="0"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Category</label>
                <select value={category} onChange={e => setCategory(e.target.value)}>
                  {categories.map(cat => (
                    <option key={cat} value={cat}>{cat}</option>
                  ))}
                </select>
              </div>

              <label className="checkbox-option">
                <input
                  type="checkbox"
                  checked={featured}
                  onChange={e => setFeatured(e.target.checked)}
                />
                <span>Feature this product</span>
              </label>
            </div>

            <button
              className={`save-product-btn ${saving ? 'saving' : ''}`}
              onClick={handleSubmit}
              disabled={!name.trim() || !price || saving}
            >
              {saving ? (
                <span className="spinner" />
              ) : (
                'Add Product'
              )}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default AddProductModal;
